const toggleURLSearchParams = (
  oldUrlSearchParams: URLSearchParams,
  keyToAdd: string,
  valueToAdd: string
) => {
  const newVariantUrlParams = new URLSearchParams();
  // set new params
  newVariantUrlParams.set("format", "json");
  newVariantUrlParams.set(keyToAdd, valueToAdd);

  // copy old params
  for (var pair of oldUrlSearchParams.entries()) {
    const [paramKey, param] = pair;
    if (!newVariantUrlParams.has(paramKey)) {
      newVariantUrlParams.set(paramKey, param);
    }
  }

  // toggle param if already exists
  if (oldUrlSearchParams.get(keyToAdd) === valueToAdd) {
    newVariantUrlParams.delete(keyToAdd);
  }

  return newVariantUrlParams;
};

export default toggleURLSearchParams;
